import { MedicalInformationType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { Table } from '@dreryk/react-components';

import { TABLE_PAGE_SIZE } from '../shared/constants';

import {
   useMedicalInformationDataConfiguration,
   useMedicalInformationTableColumns,
} from './MedicalInformationTable.hooks';

type MedicalInformationTableProps = {
   readonly patientId: number;
   readonly medicalInformationType: MedicalInformationType;
   readonly highlightedEntryId?: number;
};

export const MedicalInformationTable = (props: MedicalInformationTableProps): JSX.Element => {
   const dataConfiguration = useMedicalInformationDataConfiguration(props.patientId, props.medicalInformationType);
   const columns = useMedicalInformationTableColumns(dataConfiguration.refetch);

   return (
      <Table
         testId={'medicalInformation'}
         keyExtractor={'id'}
         columns={columns}
         dataConfiguration={dataConfiguration}
         pageSize={TABLE_PAGE_SIZE}
         highlightedRowKey={props.highlightedEntryId}
      />
   );
};
